import { createSelector } from '@reduxjs/toolkit';
import { CHNodeGetSortFn } from '../../../../general/node';
import { RootSelector } from '../../../models/rootSelector';
import { getSearchParams } from '../../app/selectors';
import { FileManagerRow } from '../model';
import { secondaryColumns } from '../secondaryColumns';
import { getFileManager, getNodes, getSortBy } from './selectors';
import { getIgnoreFilters, getNodesFiltered } from './selectors2';

export const getTableData: RootSelector<FileManagerRow[]> = createSelector(
  [getNodesFiltered, getSortBy, getIgnoreFilters, getNodes, getSearchParams],
  (filtered, sortBy, ignoreFilters, all, searchParamsContext) => {
    const column = secondaryColumns.find((x) => x.key === sortBy.key);
    const getter = column?.column.getter;
    const nodes = ignoreFilters ? all : filtered;
    const sortFn = CHNodeGetSortFn(sortBy, getter);
    const enrichNodes = nodes.map((node) => ({ ...node, searchParamsContext }));
    const sortedNodes = enrichNodes.sort(sortFn);
    return sortedNodes;
  },
);

export const getSelectedRange: RootSelector<FileManagerRow[] | null> = createSelector(
  [getTableData, getFileManager],
  (sorted, fm) => {
    const { lastNodeIDSelected, firstNodeIDSelected } = fm;
    if (lastNodeIDSelected === null || firstNodeIDSelected === null) {
      return null;
    }
    const lastNodeIndex = sorted.findIndex((x) => x.id === lastNodeIDSelected);
    const firstNodeIndex = sorted.findIndex((x) => x.id === firstNodeIDSelected);
    if (lastNodeIndex === -1 || firstNodeIndex === -1) {
      return null;
    }
    const start = Math.min(lastNodeIndex, firstNodeIndex);
    const end = Math.max(lastNodeIndex, firstNodeIndex) + 1;
    return sorted.slice(start, end);
  },
);
